import { Calendar, formatDate } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from "@fullcalendar/list";

export default function AlumniCalendar(today) {
	let calendarEL = document.querySelector("#calendar.alumni");
	if (null == calendarEL) return;

	let alumni_calendar = new Calendar(calendarEL, {
		plugins: [listPlugin, dayGridPlugin],
		headerToolbar: {
			left: "prev,next today",
			center: "title",
			right: "listYear dayGridMonth",
		},
		height: "auto",
		initialView: "listYear",
		initialDate: today,
		navLinks: true, // can click day/week names to navigate views
		editable: false,
		dayMaxEvents: false, // allow "more" link when too many events
		listDayFormat: {
			weekday: "long",
			month: "short",
			day: "2-digit",
		},
		listDaySideFormat: false,
		events: Object.values(renbrook.calendar.events),
		eventContent: function (info) {
			// Customize the event HTML here

			return {
				html:
					'<div class="fc-content">' +
					info.event.title +
					(info.event.extendedProps.Location
						? "<p>" + info.event.extendedProps.Location + "</p>"
						: "") +
					(info.event.extendedProps.Description
						? "<p>" + info.event.extendedProps.Description + "</p>"
						: "") +
					"</div>",
			};
		},
	});

	alumni_calendar.render();
}
